<template >
  <div class="full-height full-weight">
    <div class="row items-center justify-center no-scroll" v-if="loading">
      <loading class="q-ma-lg" />
    </div>

    <div
      v-else-if="currentSample && currentSample.length"
      class="
        relative-position
        q-ma-lg
        rounded-borders
        no-scroll
        full-height
        col-grow
      "
    >
      <div
        style="position: absolute; right: 10px; top: 10px; z-index: 999"
        class="bmap-custom-marker-controller"
      >
        <div
          class="bmap-custom-marker-control"
          :class="{
            'bmap-custom-marker-control-active':
              selectedType === type.key_prefix,
          }"
          v-for="type in pointType"
          :key="type.key_prefix"
          @click="selectedType = type.key_prefix"
        >
          {{ type.label }}
        </div>
      </div>
      <div
        class="fit rounded-borders"
        id="_tlqn_admin_sg_detail_distribution"
      ></div>
    </div>
  </div>
</template>
<script>
import BMapMixin from "@/mixins/bmap.mixin";
const customMarkPointLoader = () => import("@/libs/CustomMarkPoint");
const customMakePointControlLoader = () =>
  import("@/libs/CustomMarkPointStyleController");
export default {
  mixins: [BMapMixin],
  components: {
    Loading: () => import("@/components/Loading"),
  },

  data() {
    return {
      loading: false,
      pointType: [
        { key_prefix: "all", label: "全部" },
        { key_prefix: "dom", label: "注册地址" },
        { key_prefix: "addr", label: "经营地址" },
        { key_prefix: "entname", label: "地图检索地址" },
      ],
      selectedType: "all",
    };
  },

  props: {
    sample: {},
  },

  watch: {
    selectedType(newType) {
      if (newType) {
        this.renderMap();
      }
    },
  },
  mounted() {
    this.renderMap();
  },
  computed: {
    currentSample() {
      return [this.sample];
    },
  },
  methods: {
    async renderMap() {
      const { currentSample } = this;
      if (!currentSample || !currentSample.length) {
        return;
      }
      this.loading = true;
      const BMap = await this.loadBmap();
      const CustomMarkPoint = (await customMarkPointLoader()).default;
      const CustomMarkPointStyleController = (
        await customMakePointControlLoader()
      ).default;
      this.loading = false;
      this.$nextTick(() => {
        const map = new BMap.Map("_tlqn_admin_sg_detail_distribution");
        map.enableScrollWheelZoom(true);
        // 添加控件
        // 切换筛选内容的控件
        // map.addControl(new BMap.ScaleControl());
        const markPointStyleController = new CustomMarkPointStyleController();
        map.addControl(markPointStyleController);

        const { center, scale } = this.calculatePointsCenterAndScale(
          currentSample.map((sample) => [
            sample.detail.dom_lon,
            sample.detail.dom_lat,
          ]),
          "#_tlqn_admin_sg_detail_distribution"
        );
        map.centerAndZoom(new BMap.Point(...center), scale);
        let showPoint = [];
        const lng_key = `${this.selectedType}_lon`;
        const lat_key = `${this.selectedType}_lat`;
        if (this.selectedType === "all") {
          showPoint = [
            {
              lon: this.sample.detail.dom_lon,
              lat: this.sample.detail.dom_lat,
            },
            {
              lon: this.sample.detail.addr_lon,
              lat: this.sample.detail.addr_lat,
            },

            {
              lon: this.sample.detail.entname_lon,
              lat: this.sample.detail.entname_lat,
            },
          ];
        } else {
          showPoint = [
            {
              lon: this.sample.detail[lng_key],
              lat: this.sample.detail[lat_key],
            },
          ];
        }
        showPoint.forEach((gis) => {
          if (gis.lon === null && this.selectedType != "all") {
            this.$q.notify({
              type: "danger",
              message: "数据缺失",
            });
          }
          const bmapPoint = new BMap.Point(gis.lon, gis.lat);
          // const MarkPoint = new BMap.Marker(bmapPoint);
          const MarkPoint = new CustomMarkPoint(
            this.sample.id,
            bmapPoint,
            this.sample.detail.name,
            this.sample.detail.sample_id
          );

          map.addOverlay(MarkPoint);
        });
      });
    },
  },
};
</script>
<style lang="">
</style>